import React from "react";

type FlexProps = {
	display?: "flex" | "inline-flex";
	style?: React.CSSProperties;
	className?: string;
	children: React.ReactNode;
} & Pick<
	React.CSSProperties,
	| "flexDirection"
	| "flexWrap"
	| "flexFlow"
	| "justifyContent"
	| "alignItems"
	| "alignContent"
	| "gap"
	| "rowGap"
	| "columnGap"
>;

export function Flex({ display = "flex", style = {}, className, children, ...props }: FlexProps) {
	return (
		<div style={{ display, ...style, ...props }} className={className}>
			{children}
		</div>
	);
}
